module.exports = __webpack_public_path__ + "static/media/forgotPassword.e5585993.jpg";